const Perks = () => {
    return ( 
      <>
         <div class="roadmap"  id="perk">
            <div class="container">
               <h3><em>PER</em>KS:</h3>
               <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-6">
                     <div class="content_perk content_perk1">
                        <h1>Passive Income</h1>
                        <p>Staking and Tokens - Metaverse involvement and monetization of property & royalty implementation via Crypto Pilot will be redistributed back to collectors.</p>
                     </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6">
                     <div class="content_perk content_perk2">
                        <h1>Excursions</h1>
                        <p>International Crypto Pilot Collector Exclusive Meetups, Animal Viewings, Sports Events, Music Events & more.</p>
                     </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6">
                     <div class="content_perk content_perk3">
                        <h1>Pride</h1>
                        <p>Doing something more than just collecting NFT’s. Helping to make the world a better place. This truly is the most important benefit.</p>
                     </div>
                  </div>
               </div>
               <div class="row roadmap_row1">
                  <div class="col-lg-4 col-md-4 col-sm-6">
                     <div class="content_perk content_perk4 payout">
                        <h1>Rights</h1>
                        <p>Ownership and commercial usage rights of their NFT(s). Use it for a shirt, for promotions, to start up your own project.. whatever YOU want to do with it.</p>
                     </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6">
                     <div class="content_perk content_perk5">
                        <h1>Prizes</h1>
                        <p>Enjoy random monthly prizes from 2.5% of the "second-market royalties".</p>
                     </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-6">
                     <div class="content_perk content_perk6">
                        <h1>Bright Future</h1>
                        <p>Endorsement opportunities with brands for Pilot holders.  Priority Mint Rights for a "Surprise" NFT.   Whitelist guarantee for future Universal Space Station projects.</p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
     );
}
 
export default Perks;